module.exports = __webpack_public_path__ + "static/carousel-slide-06-5af6de20ee8977a2768cc61921891b7d.png";